module.exports = function() {
  return new Worker(__webpack_public_path__ + "90aaa8291c21f9b54a0a.worker.js");
};